module.exports = __webpack_public_path__ + "static/media/man--big.ad7a9d24.png";